var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: { "mask-closable": false, width: "488" },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "p",
        { staticClass: "modalHead", attrs: { slot: "header" }, slot: "header" },
        [_c("span", [_vm._v(_vm._s(_vm.$t("webList.webDetail.paymentToday")))])]
      ),
      _c("div", { staticClass: "modalContent" }, [
        _c("p", [
          _vm._v(_vm._s(_vm.$t("webList.webDetail.paymentTip")) + ": "),
          _c("a", { staticStyle: { color: "#00A3EE" } }, [
            _vm._v(
              _vm._s(_vm.currency) +
                " " +
                _vm._s(_vm.$filters.money(_vm.todayWithdrawnumber))
            ),
          ]),
        ]),
      ]),
      _c("div", {
        staticClass: "textright",
        attrs: { slot: "footer" },
        slot: "footer",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }